var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2935 4.87868L9.87928 6.29289C9.48876 6.68342 9.48876 7.31658 9.87928 7.70711L11.2935 9.12132C11.684 9.51184 12.3172 9.51184 12.7077 9.12132L14.1219 7.70711C14.5124 7.31658 14.5124 6.68342 14.1219 6.29289L12.7077 4.87868C12.3172 4.48816 11.684 4.48816 11.2935 4.87868ZM8.46507 4.87868C7.2935 6.05025 7.2935 7.94975 8.46507 9.12132L9.87928 10.5355C11.0509 11.7071 12.9504 11.7071 14.1219 10.5355L15.5361 9.12132C16.7077 7.94975 16.7077 6.05025 15.5361 4.87868L14.1219 3.46447C12.9504 2.29289 11.0509 2.29289 9.87928 3.46447L8.46507 4.87868Z",
    fill: "#6F767E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2935 14.8787L3.87928 16.2929C3.48876 16.6834 3.48876 17.3166 3.87928 17.7071L5.2935 19.1213C5.68402 19.5118 6.31719 19.5118 6.70771 19.1213L8.12192 17.7071C8.51245 17.3166 8.51245 16.6834 8.12192 16.2929L6.70771 14.8787C6.31719 14.4882 5.68402 14.4882 5.2935 14.8787ZM2.46507 14.8787C1.2935 16.0503 1.2935 17.9497 2.46507 19.1213L3.87928 20.5355C5.05086 21.7071 6.95035 21.7071 8.12192 20.5355L9.53614 19.1213C10.7077 17.9497 10.7077 16.0503 9.53614 14.8787L8.12192 13.4645C6.95035 12.2929 5.05086 12.2929 3.87928 13.4645L2.46507 14.8787Z",
    fill: "#6F767E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2935 14.8787L15.8793 16.2929C15.4888 16.6834 15.4888 17.3166 15.8793 17.7071L17.2935 19.1213C17.684 19.5118 18.3172 19.5118 18.7077 19.1213L20.1219 17.7071C20.5124 17.3166 20.5124 16.6834 20.1219 16.2929L18.7077 14.8787C18.3172 14.4882 17.684 14.4882 17.2935 14.8787ZM14.4651 14.8787C13.2935 16.0503 13.2935 17.9497 14.4651 19.1213L15.8793 20.5355C17.0509 21.7071 18.9504 21.7071 20.1219 20.5355L21.5361 19.1213C22.7077 17.9497 22.7077 16.0503 21.5361 14.8787L20.1219 13.4645C18.9504 12.2929 17.0509 12.2929 15.8793 13.4645L14.4651 14.8787Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiIcon);
export default __webpack_public_path__ + "static/media/api_icon.f1d90d7416a62a161aee76a4ab38fb6f.svg";
export { ForwardRef as ReactComponent };